
export default {
    // Unspecified = 0,
    // Applicant = 1,
    // Active = 2,
    // Resigned = 3,
    // Terminated = 4,
    // EndOfContract = 5,
    // OnHold = 6,
    // OnPool = 7

    getEmployeeByUserId: state => (userId) => {
        return userId !== '' ? state.allEmployee.find(u => u.id === userId) : ''
    } ,

    getEmployeeByEmployeeCode: state => (employeeCode) => {
        return employeeCode !== '' ? state.allEmployee.find(u => u.employeeCode === employeeCode) : ''
    } ,

    getEmployeeByUserName: state => (userName) => state.allEmployee.find(u => u.userName === userName),

    getAllResignedEmployees: state => () =>  state.allEmployee.filter(r => r.employeeInformation.employeeStatus>= 3 &&  r.employeeInformation.employeeStatus <= 5 ),

    getAllRealEmployees: state => () =>  state.allEmployee.filter((r) => r.employeeInformation != null),

    getAllEmployeeByStatus: state => (createPayrollTypeId, paymentModeId) =>  {
            console.log(createPayrollTypeId)
            console.log(paymentModeId)
            switch(createPayrollTypeId) {
                default:
                    return state.allEmployee.filter((u) => u.employeeInformation != null && u.employeeSalaryInformation.paymentModeId === paymentModeId && u.employeeInformation.employeeStatus === 2)
                case 3:
                  break;
                // case 5: disabled Jan 9,2023
                //     return state.allEmployee.filter((u) => u.employeeInformation != null && u.employeeSalaryInformation.paymentModeId === paymentModeId && (u.employeeInformation.employeeStatus === 2 || u.employeeInformation.employeeStatus === 3))
                case 4:
                    return state.allEmployee.filter((u) => u.employeeInformation != null && u.employeeSalaryInformation.paymentModeId === paymentModeId && (u.employeeInformation.employeeStatus >= 3 && u.employeeInformation.employeeStatus <= 5))
            }

        },
    getEmployeeByImmediateSupervisor1: state => (immediateSupervisorId) =>  state.allEmployee.filter((u) => u.employeeIdentification != null && u.employeeIdentification.immediateSupervisorId === immediateSupervisorId),

    getEmployeeByImmediateSupervisor: (state, getters) => immediateSupervisorId => {
        const e =  state.allEmployee.filter((u) => u.employeeIdentification != null && u.employeeIdentification.immediateSupervisorId === immediateSupervisorId)
        console.log('YEAH')
        console.log(state.allEmployee)
        console.log(e)
        // console.log(immediateSupervisorId)
        let data = []
        if(state.getAllEmployeeSchedule.length > 0) {
            e.forEach((u) => {
                if(getters.isEmployeeScheduleExist(u.id) == false) {
                    data.push(u)
                }
            })
            return data
        }
        return e
    },
    getApproversPriority: (state) => (userId, approversId, module) => state.employeeApprovers.find(a => a.userId === userId && a.approversId === approversId && a.module === module),

    isEmployeeScheduleExist: (state) => userId => { return state.getAllEmployeeSchedule.some((u) => u.userId === userId && u.isPosted) },

    getRolesById: state => (id) => state.getAllRoles.find(u => u.id === id),

    getRolesByName: state => (name) => state.getAllRoles.find(u => u.name === name),

    employeeAccreditation: state => (id) => state.employeeAccreditation.find(u => u.id === id),

    employeeApprovers: state => (id) => state.employeeApprovers.find(u => u.id === id),

    employeeAssociation: state => (id) => state.employeeAssociation.find(u => u.id === id),

    employeeBenefits: state => (id) => state.employeeBenefits.find(u => u.id === id),

    employeeBankInformation: state => (id) => state.employeeBankInformation.find(u => u.id === id),

    employeeClaimsLimit: state => (id) => state.employeeClaimsLimit.find(u => u.id === id),

    employeeContactReferences: state => (id) => state.employeeContactReferences.find(u => u.id === id),

    employeeEducation: state => (id) => state.employeeEducation.find(u => u.id === id),

    employeeFamilyInformation: state => (id) => state.employeeFamilyInformation.find(u => u.id === id),

    employeeInformation: state => (id) => state.employeeInformation.find(u => u.id === id),

    employeeInformationByUserId: state => (id) => state.employeeInformation.find(u => u.userId === id),

    employeeIdentification: state => (id) => state.employeeIdentification.find(u => u.id === id),

    employeeIdentificationByUserId: state => (id) => state.employeeIdentification.find(u => u.userId === id),

    employeeJobHistory: state => (id) => state.employeeJobHistory.find(u => u.id === id),

    employeeLeaveBalance: state => (id) => state.employeeLeaveBalance.find(u => u.id === id),

    employeeLeaveBalanceByLeaveTypeId: state => (leaveTypeId) => {
        console.log('PASOK')
        console.log(state.employeeLeaveBalance)
       return state.employeeLeaveBalance.filter((u) => u.leaveTypeId === leaveTypeId)
    },

    employeeLeaveBenefits: state => (id) => state.employeeLeaveBenefits.find(u => u.id === id),

    employeeMedical: state => (id) => state.employeeMedical.find(u => u.id === id),

    employeePerformance: state => (id) => state.employeePerformance.find(u => u.id === id),

    employeeSalaryInformation: state => (id) => state.employeeSalaryInformation.find(u => u.id === id),

    employeeSalary: state => (id) => state.employeeSalary.find(u => u.id === id),

    employeeTraining: state => (id) => state.employeeTraining.find(u => u.id === id),

    employeeViolation: state => (id) => state.employeeViolation.find(u => u.id === id),

    getEmployeeScheduleIfNotPosted: state => () => state.getAllEmployeeSchedule.filter(u => u.isPosted === false)

}
